export default "__VITE_ASSET__c939ce7c__"